import React from "react"
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import About from './screens/About'
import Home from './screens/Home'
import Vote from './screens/Vote'
import Result from './screens/Result'

function App() {
  return (
    <>
      <div className="absolute spot-gradient" />
      <Router>
        <Switch>
          <Route exact path="/:lang(en|es)?/" component={Home}/>
          <Route exact path="/:lang(en|es)?/about" component={About}/>
          <Route exact path="/:lang(en|es)?/vote/:groupId/:groupName?" component={Vote}/>
          <Route exact path="/:lang(en|es)?/result/:groupId/:groupName?" component={Result}/>
        </Switch>
      </Router>
    </>
  );
}

export default App;
